module.exports = __webpack_public_path__ + "static/img/53-3.381479e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/53-3.jpg
// module id = +pzo
// module chunks = 0